export default __webpack_public_path__ + "static/media/circle.9f2cea0b.svg";